import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { NHATestDirective } from '../../directives/test/test.directive';
import { CommonModule } from '@angular/common';
import { NHAAvatarComponent } from '../avatar/avatar.component';

@Component({
	selector: 'nha-user-info-cell',
	templateUrl: './user-info-cell.component.html',
	styleUrls: ['./user-info-cell.component.scss'],
	encapsulation: ViewEncapsulation.None,
	imports: [NHAAvatarComponent, CommonModule, MatCheckboxModule, NHATestDirective, RouterLink]
})
export class NHAUserInfoCellComponent {
	@Input() userID: number | string;
	@Input() userGUID: string = null;
	@Input() userType: 'student' | 'staff' = 'student';
	@Input() firstName: string;
	@Input() lastName: string;
	@Input() displayName: string;
	@Input() linkUrl: string = null;
	@Input() routeUrl: string = null;
	@Input() newTab: boolean = true;
	@Input() avatarSize: number = 30;
	@Input() withCheckbox: boolean = false;
	@Input() checked: boolean = false;
	@Input() checkboxDisabled: boolean = false;
	@Input() showSelfPacedBadge: boolean = false;

	@Output()
	userChecked = new EventEmitter<{ userID: number | string; $event: MatCheckboxChange }>();
	@Output()
	userClicked = new EventEmitter<number | string>();

	get userDisplayName(): string {
		return this.displayName ? this.displayName : this.lastName + ', ' + this.firstName;
	}

	onCheckboxClicked($event: MatCheckboxChange): void {
		this.userChecked.emit({ userID: this.userID, $event });
	}
}
